// Only newsletter entry-point CTAs are handled; every other click stays on
// the plugins' own automatic path, untouched.
const PREFIX = 'iiris_nl:';

const cls = (el) => (typeof el.className === 'string' ? el.className : '');
const mod = (el) => (el.dataset && el.dataset.module) || '';

const marker = (el) => ((el.dataset && el.dataset.testid) || '') + ' ' + cls(el);

const isNewsletter = (el) =>
  /newsletter/i.test(marker(el)) ||
  /newsletter/i.test(mod(el.closest('[data-module]') || el));

const isConversion = (el) => el.closest('form') !== null;
const MODAL = '[role="dialog"],[aria-modal="true"],[data-testid*="modal"],[class*="Modal"]';
const NOT_ENTRY = /close|cancel|dismiss|return|back|error|submit/i;
const isInFlow = (el) => el.closest(MODAL) !== null || NOT_ENTRY.test(marker(el));

export const isEntryCta = (el) =>
  el.tagName === 'BUTTON' &&
  isNewsletter(el) &&
  !isConversion(el) &&
  !isInFlow(el) &&
  !el.name;

const SCRIPT_PROTOCOL = /^(javascript|vbscript|jscript|mocha|livescript|ecmascript):/i;

export function isNewsletterLink(el) {
  try {
    const href = el.getAttribute('href');
    if (!href || SCRIPT_PROTOCOL.test(el.href || '')) return false;
    return /newsletter|signup|sign-up/i.test(new URL(el.href, window.location.href).pathname);
  } catch (e) {
    return false;
  }
}

const cap = (s) => (s.length > 4096 ? s.substring(0, 4096) : s);

const closestData = (el, sel, key) => el.closest(sel)?.dataset[key] || '';

export function sourceValue(el) {
  let loc = '';
  try { loc = el.href ? new URL(el.href, window.location.href).searchParams.get('location') || '' : ''; } catch (e) {}
  return cap(PREFIX + (loc
    || (el.dataset && el.dataset.testid)
    || closestData(el, '[data-module]', 'module')
    || closestData(el, '[data-testid]', 'testid')
    || 'unknown'));
}

export const label = (el) => cap(el.innerText || '(empty)');
export const cssClasses = (el) => cls(el).match(/\S+/g) || [];

